import React from 'react';
import PropTypes from 'prop-types';
import LoadableHOC from '../LoadableHOC';
import Submit from '../formComponents/Submit';

const LoadableSubmit = (props) => {
  const onChange = (name, value) => {
    props.onChange(name,
      value);
  };

  return (<Submit {...props} onChange={onChange} />);
};

LoadableSubmit.PropTypes = {
  onChange:PropTypes.func,
};

export default LoadableHOC(LoadableSubmit);
